module.exports = __webpack_public_path__ + "static/media/girl-icon-biz-full.e9818e63.png";